import { Colors } from '../../consts/Colors.js';
import RoundedButton2 from '../RoundedButton2.js';
import Card4 from './Card4.js';
import { CartesInfos, TextContents } from '../../consts/DataGame4.js';
import DragManager from '../DragManager.js';
import EndBoard from '../EndBoard.js';

// Création du deck de jeu pour la partie 4

export default class Deck4 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, zones) {
        super(scene, x, y, []);
        scene.add.existing(this);

        this.scene = scene;
        this.isFirstDrop = true
        this.placeholders = [];
        this.cartes = [];


        this.rect = this.scene.add.rexRoundRectangle(0, 0, 416, 593, 26, Colors.Elmt.Beige).setOrigin(0.5);
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.add(this.rect);

        this.validBtn = new RoundedButton2(this.scene, 0, 247, 154, "Valider");
        this.add(this.validBtn);
        this.validBtn.setClickFunction(() => {
            this.checkAnswer()
        })

        this.dragManager = new DragManager(this.scene);
        for (let i = 0; i < CartesInfos.length; i++) {
            const el = CartesInfos[i];
            // let ph = this.scene.add.image(el.cardX, el.cardY, el.image + "_placeholder").setOrigin(0.5);
            let ph = this.scene.add.rexRoundRectangle(el.cardX, el.cardY, 350, 40, 8, Colors.Elmt.White).setOrigin(0.5);
            this.add(ph);
            ph.setAngle(el.angle)
            this.placeholders.push(ph);

            this.carte = new Card4(this.scene, 0, el.cardY, el, this, ph);
            this.add(this.carte);
            this.cartes.push(this.carte);
            this.dragManager.addDraggable(this.carte);

            zones.getChildren().forEach(zone => {
                if(zone.zoneId === el.zoneId){
                    this.carte.zoneCorrect = zone;
                }
            });
        }

        this.validBtn.setLocked()

        this.title = this.scene.createTextElement(-171, -474, TextContents.title)
        this.subtitle = this.scene.createTextElement(-171, this.title.y + this.title.height + 16, TextContents.subtitle)
        this.consigne = this.scene.createTextElement(-167, 352, TextContents.consigne)
        this.add(this.title)
        this.add(this.subtitle)
        this.add(this.consigne)

    }
    setDeckTrue() {
        this.repLogo = this.scene.add.image(-93, -60, 'goodAnswer').setOrigin(0.5)
        this.add(this.repLogo)
        this.repText = this.scene.add.text(-59, -75, "BRAVO", {
            font: "40px MassiliaBold",
            color: Colors.Text.Green
        }).setOrigin(0)
        this.add(this.repText)
        this.repContent = this.scene.add.text(0, -25, TextContents.bravo.text, {
            font: "22px MassiliaRegular",
            color: Colors.Text.Blue,
            align: "center",
            wordWrap: { width: 360, useAdvancedWrap: true }
        }).setOrigin(0.5, 0)
        this.add(this.repContent)
        this.nextBtn = new RoundedButton2(this.scene, 0, 231, 188, "Continuer");
        this.add(this.nextBtn);
        this.cartes.forEach(carte => {
                console.log(carte.isCorrect, carte.zoneCorrect);
                if (carte.isCorrect && carte.zoneCorrect != undefined) {
                    carte.zoneCorrect.destroy()
                    carte.zoneCorrect = undefined
                }
                this.scene.setActionBackground(carte.zoneId)

            })
        this.nextBtn.setClickFunction(() => {
            this.addEndBoard()
        })
    }
    setDeckFalse(score) {
        let content
        let nbMauvaiseReponse = this.cartes.length - score
        if (nbMauvaiseReponse == 1) {
            content = nbMauvaiseReponse + " MAUVAISE RÉPONSE"
        } else {
            content = nbMauvaiseReponse + " MAUVAISES RÉPONSES"
        }

        this.repLogo = this.scene.add.image(0, -72, 'badAnswer').setOrigin(0.5)
        this.add(this.repLogo)
        this.repText = this.scene.add.text(0, -24, content, {
            font: "40px MassiliaBold",
            color: Colors.Text.Red,
            wordWrap: { width: 255, useAdvancedWrap: true },
            align: "center"
        }).setOrigin(0.5, 0)
        this.add(this.repText)
        this.nextBtn = new RoundedButton2(this.scene, 0, 245, 188, "Réessayer");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => {
            this.cartes.forEach(carte => {
                console.log(carte.isCorrect, carte.zoneCorrect, carte.zoneDropped);
                if(carte.zoneCorrect == undefined) return
                if (carte.zoneDropped != undefined && carte.zoneDropped !== null) {
                    carte.zoneDropped.reset()
                }
                carte.reset()
            })
            this.cartes.forEach(carte => {
                console.log(carte.isCorrect, carte.zoneCorrect);
                if (carte.isCorrect && carte.zoneCorrect != undefined) {
                    carte.zoneCorrect.destroy()
                    carte.zoneCorrect = undefined
                }
            })

            this.nextBtn.destroy()
            this.placeholders.forEach(ph => { ph.setAlpha(1) })
            this.validBtn.setAlpha(1)
            this.validBtn.setLocked()
            this.repLogo.destroy()
            this.repText.destroy()
        })
    }

    checkAnswer() {
        this.result = 0
        this.cartes.forEach(carte => {
            carte.disableInteractive()
            if (carte.zoneDropped.zoneType === carte.zoneType) {
                if (carte.isFirstDrop === true) {
                    this.scene.game.data.score.bravo++
                }
                carte.setGood()
                carte.isCorrect = true
                this.result++
            } else {
                carte.isCorrect = false
                if (carte.isFirstDrop === true) {
                    this.scene.game.data.score.mauvais++
                }
                carte.setBad()
            }
            carte.isFirstDrop = false
        })
        this.placeholders.forEach(ph => { ph.setAlpha(0) })
        this.validBtn.setAlpha(0)
        if (this.result == this.cartes.length) {
            this.setDeckTrue()
        } else {
            this.setDeckFalse(this.result)
        }
    }

    addEndBoard() {
        this.subtitle.setAlpha(0)
        this.consigne.setAlpha(0)
        this.placeholders.forEach(ph => { ph.setAlpha(0) })
        this.validBtn.setAlpha(0)
        this.rect.setAlpha(0)
        if (this.repLogo) this.repLogo.setAlpha(0)
        if (this.repText) this.repText.setAlpha(0)
        if (this.repContent) this.repContent.setAlpha(0)
        if (this.nextBtn) this.nextBtn.setAlpha(0)

        let endBoard = new EndBoard(0, 225 - 540, this.scene, this.scene.game.data.score)
        this.add(endBoard)
    }

    update(){
        let nbr = this.cartes.filter(x => x.isDone).length
        if (nbr == this.cartes.length) {
            this.validBtn.setUnlocked()
        }
    }
}
